import { render, staticRenderFns } from "./IconAvatar.vue?vue&type=template&id=d0114a54&"
import script from "./IconAvatar.vue?vue&type=script&lang=js&"
export * from "./IconAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports